import React, { useContext } from 'react';
import { Paper } from "@material-ui/core";
import { Template } from "devextreme-react";
import DataGrid, { FilterRow, SearchPanel } from "devextreme-react/data-grid";
import { ToolbarExportButton, ToolbarRefreshButton, ToolbarFilterFields } from './ToolbarItems';
import { useIsPhoneView } from '../../hooks/useIsPhoneView';
import { ChangelogContext } from './ChangelogContext';
import { createColumn } from './utils/createColumn';
import { useTranslation } from '@michelin/central-provider';
export const ChangelogTableView = (props) => {
    const { onToolbarPreparing, dataSource, paperHeight, height, timeZone, renderResultsCounter, } = props;
    const { t } = useTranslation();
    const isPhoneView = useIsPhoneView();
    const { changelogTableConfig } = useContext(ChangelogContext);
    const { columns: columnConfigs, metadata } = changelogTableConfig;
    const columns = columnConfigs === null || columnConfigs === void 0 ? void 0 : columnConfigs.map((columnConfig, index) => {
        return createColumn({
            columnConfig,
            index,
            isPhoneView,
            metadata,
            timeZone,
        });
    });
    return (React.createElement(Paper, { style: { height: paperHeight } },
        React.createElement(DataGrid, Object.assign({ dataSource: dataSource, remoteOperations: true, noDataText: 'No data', className: `freespaced-table ${isPhoneView ? 'phone-view' : ''}`, scrolling: { mode: 'virtual', rowRenderingMode: 'virtual' } }, (height && { style: { height: height } }), { onToolbarPreparing: onToolbarPreparing, allowColumnReordering: true, allowColumnResizing: true, columnAutoWidth: true }),
            React.createElement(Template, { name: "exportCsv", component: ToolbarExportButton }),
            React.createElement(Template, { name: "refreshData", component: ToolbarRefreshButton }),
            React.createElement(Template, { name: "resultsCounter", render: renderResultsCounter }),
            React.createElement(Template, { name: "filterFields", component: ToolbarFilterFields }),
            React.createElement(SearchPanel, { visible: true, highlightSearchText: false, placeholder: t('Search...') }),
            React.createElement(FilterRow, { visible: false }),
            columns)));
};
//# sourceMappingURL=ChangelogTableView.js.map